import styled from "styled-components";
import { Text as BaseText } from "./live-rdc";

export const Grid = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: -0.8rem;

  ${({ theme }) => theme.media.md`
    margin: -0.6rem;
  `}
`;

export const Cell = styled.div`
  width: 50%;
  flex-grow: 1;
  padding: 0.8rem;

  ${({ theme }) => theme.media.md`
    width: 100%;
    padding: 0.6rem;
  `}
`;

export const Card = styled.div`
  display: flex;
  padding: 1.2rem 1.6rem;
  background: #fff;
  box-shadow: 0 0 0.1rem rgba(0, 0, 0, 0.2), 0 0.1rem 0.2rem rgba(0, 0, 0, 0.1);
  border-radius: 0.6rem;
`;

export const CardIcon = styled.div`
  flex-shrink: 0;
  margin-right: 2.4rem;
  color: ${({ theme }) => theme.live.colors.primary};

  svg {
    width: 2rem;
    height: 2rem;
  }
`;

export const Text = styled(BaseText)`
  color: #181c24;
`;
